export default "__VITE_ASSET__uI72$Tuq__"